"use client";

import type React from "react";

import { Search } from "lucide-react";
import { Input } from "@components/ui/input";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import { ScrollTrigger } from "gsap/all";
import gsap from "gsap";

interface SearchInputProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function SearchInput({
  searchQuery,
  onSearchChange,
}: Readonly<SearchInputProps>) {
  const containerRef = useRef(null);

  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);
      gsap.fromTo(
        "#faqSearch",
        { autoAlpha: 0 },
        {
          autoAlpha: 1,
          duration: 0.5,
          scrollTrigger: {
            trigger: "#faqSearch",
            start: "top bottom-=300",
            toggleActions: "play none none reverse",
          },
        },
      );
    },
    { scope: containerRef },
  );

  return (
    <div ref={containerRef} className="mb-4">
      <div
        id="faqSearch"
        className="relative mx-auto max-w-2xl overflow-hidden"
      >
        <Input
          type="text"
          placeholder="Search FAQs..."
          value={searchQuery}
          onChange={onSearchChange}
          className="w-full rounded-none pr-10 text-sm md:text-base"
          aria-label="Search FAQs"
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <Search className="h-4 w-4 text-gray-400" />
        </div>
      </div>
    </div>
  );
}
